<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <div>
                    <el-button type="primary" @click="addClinic" style="width: 96px">新增诊所</el-button>
                </div>
            </div>
            <div>
                <el-table :data="tableData"
                          :header-cell-style="{'padding-left': '3%'}"
                          :cell-style="{'padding-left': '3%'}">
                    <el-table-column prop="hospitalName" label="诊所名称"></el-table-column>
                    <el-table-column prop="account" label="账号"></el-table-column>
                    <el-table-column prop="status" label="地址"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="editClinic(scope.row)">编辑</el-button>
                            <el-button type="text" class="delete-button" @click="deleteClinic(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <el-dialog title="新增诊所" :visible.sync="dialogAddVisible" width="520px"
                   :close-on-click-modal="false" :before-close="cancelAdd">
            <el-form :model="clinicAdd" :rules="rules" ref="add" size="small" label-width="90px">
                <el-form-item label="诊所名称:" prop="clinicName">
                    <el-input v-model="clinicAdd.clinicName" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="配置账号:" prop="user">
                    <el-select
                            style="width: 282px;"
                            v-model="clinicAdd.user"
                            filterable
                            remote
                            reserve-keyword
                            placeholder="请输入员工姓名"
                            :remote-method="getUser">
                        <el-option
                                v-for="item in userList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelAdd" style="width: 76px">取 消</el-button>
                <el-button type="primary" @click="confirmAdd" style="width: 76px;">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="编辑诊所" :visible.sync="dialogEditVisible" width="520px"
                   :close-on-click-modal="false" :before-close="cancelEdit">
            <el-form :model="clinicEdit" :rules="rules" ref="edit" size="small" label-width="90px">
                <el-form-item label="诊所名称:" prop="clinicName">
                    <el-input v-model="clinicEdit.clinicName" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="配置账号:" prop="user">
                    <el-select
                            style="width: 282px;"
                            v-model="clinicEdit.user"
                            filterable
                            remote
                            reserve-keyword
                            placeholder="请输入员工姓名"
                            :remote-method="getUser">
                        <el-option
                                v-for="item in userList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelEdit" style="width: 76px">取 消</el-button>
                <el-button type="primary" @click="confirmEdit" style="width: 76px;">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                authorization:localStorage.getItem('authorization'),
                tableData: [
                    {
                        hospitalName: '嘉兴二院',
                        chargePerson: '乔丹',
                        account: '15068322657',
                        password: '888888',
                        address: ["guangdong","guangzhou","tianhe"],
                        fullAddress: '没得事的烦恼',
                        medicinesDosage: ['中药颗粒','中药饮片'],
                        decoction: '代煎',
                        prescribe: '按袋',
                        status: '正常',
                    }
                ],
                // 分页信息
                pageNum: 1,
                pageSize: 10,
                total: 1,
                pages: 1,
                userList: [],
                dialogAddVisible: false,
                clinicAdd: {
                    clinicName: '',
                    user: '',
                    pharmacy: '',
                },
                rules: {
                    clinicName: [{required: true, message: '请输入诊所名称', trigger: 'blur'}],
                    user: [{required: true, message: '请选择登录账号', trigger: 'change'}],
                },
                dialogEditVisible: false,
                clinicEdit: {
                    clinicId: '',
                    clinicName: '',
                    province: '',
                    city: '',
                    district: '',
                    address: '',
                    user: '',
                    pharmacy: '',
                },
            };
        },
        methods: {
            // 获取诊断列表
            getData() {
                console.log("aaa")
            },
            // 表格换页
            handlePageChange(val) {
                this.pageNum = val;
                this.getData();
            },
            cancelAdd() {
                this.dialogAddVisible = false
                this.$nextTick(() => {
                    this.$refs.add.resetFields()
                })
            },
            // 新增医院弹窗按钮
            addClinic() {
                this.overPharmacy = []
                this.dialogAddVisible = true
            },
            getUser(query) {
                if (query !== '') {
                    setTimeout(() => {
                        this.userList = this.list.filter(item => {
                            return item.label.toLowerCase()
                                .indexOf(query.toLowerCase()) > -1;
                        });
                    }, 200);
                } else {
                    this.userList = [];
                }
            },
            // 确认新增医院
            confirmAdd() {
                this.$refs.add.validate(valid => {
                    if (valid) {
                        this.dialogAddVisible = false
                        setTimeout(() => {
                            this.$nextTick(() => {
                                this.$refs.add.resetFields()
                            })
                        },300)

                    } else{
                        this.$message.error('请按照要求正确填写相关信息')
                    }
                })
            },
            cancelEdit() {
                this.dialogEditVisible = false
                this.$nextTick(() => {
                    this.$refs.edit.clearValidate()
                })
            },
            // 新增医院弹窗按钮
            editClinic(data) {
                this.overPharmacy = []
                this.dialogEditVisible = true
            },
            confirmEdit() {

            },
            deleteClinic(data) {

            }
        }
    };
</script>

<style>

</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
    .dialog-set{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }
    .tag-box {
        width: 288px;
        min-height: 30px;
        border-radius: 5px;
        border: 1px solid #DCDFE6;
        padding: 0 15px
    }
</style>